import { useRef, useState } from 'react'
import Navbar from '../../components/navbar/navbar'
import Select from 'react-select'
import waitingTimeSvg from '../../assets/illustration/waiting-time.svg'

import { toast } from 'react-toastify'

import ProdutosService from '../../services/database/ProdutosService'
import { CustomSpinner } from '../../components/CustomSpinner'
import { CustomButton } from '../../components/CustomButton'

import { Form, Table } from 'react-bootstrap'

import {
  CheckCircleFill,
  Search,
  TrashFill,
  XCircleFill,
} from 'react-bootstrap-icons'

import '../TransferenciaEstoque/styles.css'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

export function AjusteEstoque() {
  const [produtos, setProdutos] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])

  const [productSearch, setProductSearch] = useState('')
  const [type, setType] = useState('')
  const [reason, setReason] = useState('')

  const [isLoadingProdutos, setIsLoadingProdutos] = useState(false)
  const [isRequestAdjustLoading, setIsRequestAdjustLoading] = useState(false)

  const buttonSearchRef = useRef(null)

  const optionsTipoAjuste = [
    {
      label: 'Entrada',
      value: 'Entrada',
    },
    {
      label: 'Saída',
      value: 'Saída',
    },
  ]

  const typeEntrada = [
    {
      label: 'Compra',
      value: 'Compra',
    },
    {
      label: 'Troca',
      value: 'Troca',
    },
    {
      label: 'Devolução',
      value: 'Devolução',
    },
  ]

  const typeSaida = [
    {
      label: 'Venda',
      value: 'Venda',
    },
    {
      label: 'Troca',
      value: 'Troca',
    },
    {
      label: 'Devolução',
      value: 'Devolução',
    },
    {
      label: 'Avaria',
      value: 'Avaria',
    },
  ]

  function handleQtdToTransfer(value, index) {
    const updatedProducts = [...selectedProducts]
    updatedProducts[index].quantityToTransfer = value

    setSelectedProducts(updatedProducts)
  }

  async function handleSearchProduct() {
    setIsLoadingProdutos(true)

    try {
      const produtosData = await ProdutosService.getAllToAdjust(
        localStorage.idconta,
        productSearch,
      )

      if (produtosData.length === 0) {
        toast.error('Não foi possível encontrar este produto!')
      }

      setProdutos(produtosData)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao listar os produtos!')
    } finally {
      setIsLoadingProdutos(false)
    }
  }

  function handleSelectProduct(product) {
    for (const selectedProduct of selectedProducts) {
      if (selectedProduct.codproduto === product.codproduto) {
        setProdutos((prevState) => prevState.filter((prod) => prod !== product))
        return
      }
    }

    setProdutos((prevState) => prevState.filter((prod) => prod !== product))

    setSelectedProducts((prevState) => [
      ...prevState,
      { ...product, quantityToTransfer: 0 },
    ])
  }

  function resetStates() {
    setProdutos([])
    setSelectedProducts([])
    setProductSearch('')
    setType('')
    setReason('')
    setIsLoadingProdutos(false)
    setIsRequestAdjustLoading(false)
  }

  async function handleSubmit(e) {
    e.preventDefault()

    setIsRequestAdjustLoading(true)

    try {
      await ProdutosService.updateStock({
        type,
        reason,
        selectedProducts,
      })

      toast.success('Estoque ajustado com sucesso!')

      resetStates()
    } catch (error) {
      console.log(`Erro ao transferir o estoque: ${error}`)
      toast.error('Erro ao transferir o estoque!')
    } finally {
      setIsRequestAdjustLoading(false)
    }
  }

  return (
    <>
      <Navbar />

      <form
        onSubmit={handleSubmit}
        className="m-4"
        style={{ width: '100%' }}
      >
        <div
          id="content-transfer"
          className="mt-page"
        >
          <h1> Ajuste de Estoque </h1>

          <section className="inputs">
            <div
              style={{
                display: 'flex',
                gap: 20,
              }}
            >
              <article
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Select
                  placeholder="Selecione a movimentação"
                  options={optionsTipoAjuste}
                  value={type}
                  onChange={(e) => {
                    setType(e)
                    setReason('')
                    setSelectedProducts([])
                  }}
                />
              </article>

              <article
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Select
                  placeholder="Selecione o motivo"
                  isDisabled={!type}
                  options={type.value === 'Entrada' ? typeEntrada : typeSaida}
                  value={reason}
                  onChange={setReason}
                />
              </article>

              <article
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ display: 'flex' }}>
                  <Form.Control
                    value={productSearch}
                    onChange={(e) => setProductSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        buttonSearchRef.current?.click()
                      }
                    }}
                    placeholder="Digite o sku ou a descrição"
                  />

                  <CustomButton
                    ref={buttonSearchRef}
                    isDisabled={!productSearch}
                    isLoading={isLoadingProdutos}
                    onClick={handleSearchProduct}
                  >
                    <Search />
                  </CustomButton>
                </div>
              </article>
            </div>
          </section>

          <section id="center">
            {isLoadingProdutos ? (
              <CustomSpinner />
            ) : !isLoadingProdutos && produtos.length > 0 ? (
              <div id="produtos">
                <header
                  style={{
                    height: '30px',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CustomButton
                    onClick={() => setProdutos([])}
                    styles={{
                      position: 'absolute',
                      right: 0,
                    }}
                  >
                    <XCircleFill />
                  </CustomButton>
                </header>

                <div id="produtos-list">
                  {produtos.map((produto) => (
                    <article
                      key={Math.random()}
                      onClick={() => handleSelectProduct(produto)}
                    >
                      <p>
                        <strong>{produto.sku}</strong> - {produto.descricao}
                      </p>
                    </article>
                  ))}
                </div>
              </div>
            ) : (
              !isLoadingProdutos &&
              selectedProducts.length === 0 &&
              produtos.length === 0 && (
                <img
                  src={waitingTimeSvg}
                  style={{ width: 400 }}
                />
              )
            )}

            {!isLoadingProdutos && selectedProducts.length > 0 && (
              <>
                <div style={{ marginTop: '40px' }}>
                  <h1> Produtos Selecionados: </h1>
                  <Table
                    striped
                    bordered
                    hover
                  >
                    <thead>
                      <tr>
                        <th>Código Produto</th>
                        <th>SKU</th>
                        <th>Descrição</th>
                        <th>Quantidade do estoque</th>
                        <th>Quantidade á ajustar</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedProducts.map((product, index) => (
                        <tr key={product.codproduto}>
                          <td>{product.codproduto}</td>
                          <td>{product.sku}</td>
                          <td>{product.descricao}</td>
                          <td>{product.qtestger}</td>
                          <td>
                            <Form.Control
                              type="number"
                              min="1"
                              required
                              value={selectedProducts[index].quantityToTransfer}
                              onChange={(e) => {
                                handleQtdToTransfer(e.target.value, index)
                              }}
                            />
                          </td>
                          <td>
                            <CustomButton
                              color="#e50e0e"
                              onClick={() => {
                                setSelectedProducts((prevState) =>
                                  prevState.filter(
                                    (prod) => prod.sku !== product.sku,
                                  ),
                                )
                              }}
                            >
                              <TrashFill />
                            </CustomButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </section>

          <div
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              margin: '10px',
              display: 'flex',
            }}
          >
            <CustomButton
              type="submit"
              isLoading={isRequestAdjustLoading}
              title="Ajustar Estoque"
              isDisabled={
                selectedProducts.length === 0 || !type.value || !reason.value
              }
              color="#145a32"
            >
              <CheckCircleFill />
            </CustomButton>
          </div>
        </div>
      </form>
    </>
  )
}
